<template>
  <c-card>
    <loader v-show="loading" />
    <c-card-header>
      <strong>Menu Access</strong>
    </c-card-header>
    <c-card-body style="height: 400px; overflow: auto">
      <ol v-for="(v, k) in menu" :key="k">
        <li
          v-show="!vc.items && vc.to"
          v-for="(vc, kc) in v._children"
          :key="k * kc"
        >
          <input type="checkbox" v-model="vc.enable" />
          {{ vc.name }}
        </li>
        <li v-show="vc.items" v-for="(vc, kc) in v._children" :key="kc + k">
          <input type="checkbox" v-model="vc.enable" />
          {{ vc.name }}
          <ul>
            <li v-for="(v1, k1) in vc.items" :key="k1 + k">
              <input type="checkbox" v-model="v1.enable" />
              {{ v1.name }}
            </li>
          </ul>
        </li>
      </ol>
    </c-card-body>
    <c-card-footer>
      <button class="btn btn-success" @click="save">Save</button>
    </c-card-footer>
  </c-card>
</template>
<script>
import { HTTPAUTH } from '../lib/httplib'
import Loader from '../components/Loader.vue'
export default {
  components: { Loader },
  props: ['menu', 'userId'],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    save () {
      this.loading = true;
      HTTPAUTH.post("/api/menu/access/" + this.userId, this.menu).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    }
  }
}
</script>